import React from 'react';

// Components
import Hero from '../../Components/Hero';
import Main from '../../Components/Main';
import FAQ from '../../Components/FAQ';
import Footer from '../../Components/Footer';

function Homepage() {
  return (
    <>
      <Hero />
      <Main />
      <FAQ />
      <Footer />
    </>
  );
}

export default Homepage;
